module.exports = __webpack_public_path__ + "static/media/eupholidoptera_schmidti_011_APA.a36758a4.png";